<template>
  <section class="mt-12 w-full">
    <div>
      <div class="grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-4">
        <LazyMarketingCardActivity
          v-for="(activity, index) in sortedActivities"
          v-if="!isLoading"
          :key="index"
          :activity="activity"
          :blok="blok"
          :name="name"
          :package-card="true"
        />
        <LazyMarketingCardActivityLoading
          v-for="i in 4"
          v-if="isLoading"
          :key="i"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { PackageStoryblok } from '~/types/component-types-sb';

interface Props {
  blok: PackageStoryblok;
  uuid: string;
  type: string;
  name: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'packages-count': [count: number];
  'packages-false': [];
}>();

const { fetchPackages, isLoading } = useStoryblokClient();

const activities = ref<PackageStoryblok[]>([]);

// Computed property for sorted activities
const sortedActivities = computed(() => {
  return [...activities.value].sort((a, b) => {
    const priceA = a.content?.products?.[0]?.price ?? 0;
    const priceB = b.content?.products?.[0]?.price ?? 0;
    const priceOrder = priceB - priceA;
    if (priceOrder !== 0) return priceOrder;

    return a.name.localeCompare(b.name);
  });
});

// Load activities and set them in the reactive `activities` array
const loadActivities = async () => {
  try {
    const [stories] = await Promise.all([fetchPackages()]);

    activities.value = stories.filter((activityPackage) =>
      activityPackage.content?.activities?.some(
        (activity: { content: any; uuid: string }) =>
          activity.content && activity.uuid === props.uuid
      )
    );

    // Emit the count of packages found
    emit('packages-count', activities.value.length);

    // Emit packages-false if there are no packages
    if (activities.value.length === 0) {
      emit('packages-false');
    }
  } catch (error) {
    console.error(error);
  }
};

await loadActivities();
</script>
